var app = angular.module('leonardo');

var CategoryVendorService = function (BaseRestService) {
  return new BaseRestService('vendors-category');
};

app.factory('CategoryVendorService', ['BaseRestService', CategoryVendorService]);



